import { Toast } from 'vant';
import store from '@/store';

export function responseHandle(response) {
	switch (response.code) {
		case 10001:
			store.dispatch('user/loginOut');
			Toast('请登录');
			break;
		case 10000:
			Toast('本次请求错误，请稍后重试');
			break;
		case 10003:
			Toast(response.msg);
			break;
	}
}
